// An "on" switch is BLUE — the same blue as a primary button (`bg-blue-600`),
// which is what the rest of this product uses to mean "this is the action".
//
// It used to be `bg-primary`, and `--primary` in index.css is `240 5.9% 10%` —
// near-black. So every toggle in the app read as an off-brand dark pill sitting
// next to blue CTAs.
//
// Fixed here rather than by repointing `--primary`: that token paints
// everything else built on it too, and this is a decision about switches, not a
// theme change. Colour is stated on the component for the same reason the
// Button primitive states its own.
import * as SwitchPrimitives from "@radix-ui/react-switch";

import { cn } from "@util/tailwind";
import React from "react";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-blue-600 data-[state=unchecked]:bg-input",
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
